"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileExtensions = exports.defaultPickerOptions = exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _fileExtensions = _interopRequireDefault(require("./file-extensions"));

var _defaultPickerOptions = _interopRequireDefault(require("./default-picker-options"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var createWrapper = function createWrapper(filestack) {
  return _objectSpread(_objectSpread({}, filestack), {}, {
    upload: function upload(file, storeOptions) {
      return new Promise(function (resolve, reject) {
        filestack.store(file, storeOptions, resolve, reject);
      });
    },
    export: function _export(handle) {
      return new Promise(function (resolve) {
        filestack.exportFile(handle, resolve, resolve);
      });
    },
    exportUrl: function exportUrl(url, opts) {
      return new Promise(function (resolve) {
        filestack.exportFile(url, opts, resolve, resolve);
      });
    },
    pickAndStore: function pickAndStore(pickerOptions, storeOptions) {
      return new Promise(function (resolve, reject) {
        filestack.pickAndStore(_objectSpread(_objectSpread({}, _defaultPickerOptions.default), pickerOptions), storeOptions, resolve, reject);
      });
    }
  });
};

var _default = function _default(key, filestack) {
  filestack.setKey(key);
  return createWrapper(filestack);
};

exports.default = _default;
var fileExtensions = _fileExtensions.default;
exports.fileExtensions = fileExtensions;
var defaultPickerOptions = _defaultPickerOptions.default;
exports.defaultPickerOptions = defaultPickerOptions;